import {
  IconAward,
  // IconBike,
  IconBrain,
  IconBriefcase,
  IconBulb,
  IconDeviceDesktop,
  IconHeartHandshake,
  IconSchool,
} from "@tabler/icons-react";
import { GiAxolotl, GiCowboyBoot } from "react-icons/gi";

const inline_menu = [
  {
    name: "Experience",
    children: [
      {
        title: "Professional",
        icon: IconBriefcase,
        target: "professional",
      },
      {
        title: "Social Impact",
        icon: IconHeartHandshake,
        target: "impact",
      },
      {
        title: "Awards",
        icon: IconAward,
        target: "awards",
      },
    ],
  },
  {
    name: "Portfolio",
    children: [
      {
        title: "Full Portfolio",
        icon: IconBulb,
        target: "portfolio",
      },
      { divider: true },
      {
        title: "2022 TX Voter Tracker",
        icon: GiCowboyBoot,
        target: "2022-tracker",
      },
      {
        title: "2020 TX Voter Tracker",
        icon: GiCowboyBoot,
        target: "2020-tracker",
      },
      {
        title: "Made to Uplift",
        icon: GiAxolotl,
        target: "made-to-uplift",
      },
    ],
  },
  {
    name: "Blog",
    visible: false,
    children: [
      {
        title: "Harvard Business School",
        icon: IconSchool,
        target: "blog/hbs",
      },
      {
        title: "Tech",
        icon: IconDeviceDesktop,
        target: "blog/tech",
      },
      // {
      //   title: "Biking to Alaska",
      //   icon: IconBike,
      //   target: "blog/bike",
      // },
      {
        title: "Musings",
        icon: IconBrain,
        target: "blog/musings",
      },
    ],
  },
  {
    name: "Testimonials",
    target: "testimonials",
  },
];

export default inline_menu;
